import { PATHS } from "@/lib/router";
import { NotificationsPage } from "./pages";

export const notificationsRoutes = [
  {
    path: PATHS.NOTIFICATIONS,
    element: <NotificationsPage />,
  },
];
